<template>
    <div class="w1200 audition-page" v-loading="loading">
        <div class="audition-type" style="margin-bottom:16px;">
            <div class="desc">方案详情</div>
            <div class="actions">
                <span class="apply_sss" @click="goBack">返回栏目</span>
            </div>
        </div>

        <template v-if="detail">
            <entry-detail-panel
                :entry="detail"
                :lottery-options="lotteryOptions"
                :downloading="downloading"
                :purchasing="purchasing"
                @download="handleDownload"
                @purchase="handlePurchase" />

            <recent-record-grid
                v-if="detail.userId && detail.preType"
                :user-id="detail.userId"
                :pre-type="detail.preType"
                :user-name="detail.userName" />

            <div class="audition-action-box">
                <div class="box-title">跟单意向</div>
                <div class="follow-row">
                    <template v-if="detail.periodOperable">
                        <el-button
                            v-if="loggedIn && !detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            @click="handleFollow">表达跟单意向</el-button>
                        <el-button
                            v-else-if="detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            :loading="followCanceling"
                            @click="handleCancelFollow">取消跟单意向</el-button>
                    </template>
                    <el-tag v-else type="info">本期已截止</el-tag>

                    <span class="follow-count">
                        跟单意向：{{ detail.followIntentCount || 0 }} / {{ followThreshold }} 人
                    </span>
                    <el-tag v-if="detail.canInitCrowdfunding" type="warning">已达跟单阈值</el-tag>
                </div>
                <div class="follow-row" v-if="detail.canInitCrowdfunding" style="margin-top: 12px;">
                    <el-button type="primary" :loading="converting" @click="openCrowdfund">转为众筹招股</el-button>
                    <span class="follow-count">跟单意向达阈值后可发起众筹，向散户募集实战票资金</span>
                </div>
            </div>

            <!-- 海选转众筹招股 -->
            <el-dialog title="发起众筹招股" :visible.sync="crowdfundDialog" width="560px">
                <el-form label-width="110px" :model="crowdfundForm">
                    <el-form-item label="众筹标题">
                        <el-input v-model="crowdfundForm.title" placeholder="不填则取海选方案标题"></el-input>
                    </el-form-item>
                    <el-form-item label="彩票期号" required>
                        <el-input v-model="crowdfundForm.issueNumber" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="彩种" required>
                        <el-input :value="preTypeLabelOf(crowdfundForm.lotteryType)" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="出票站号" required>
                        <el-input v-model="crowdfundForm.bettingShopNumber" placeholder="请输入出票站号"></el-input>
                    </el-form-item>
                    <el-form-item label="出票站点" required>
                        <el-input v-model="crowdfundForm.bettingShopAddress" placeholder="请输入出票站点"></el-input>
                    </el-form-item>
                    <el-form-item label="众筹总额(元)" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingAmount" :min="1" :precision="2" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="众筹总股数" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingNumber" :min="1" :step="1" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="每股价格(缩币)" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingPrice" :min="1" :precision="2" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="每人认购上限">
                        <el-input-number v-model="crowdfundForm.personLimit" :min="0" :step="1" controls-position="right" style="width: 100%"></el-input-number>
                        <div class="form-tip">0 或不填则后端按 min(总股数,100) 设定</div>
                    </el-form-item>
                    <el-form-item label="众筹说明">
                        <el-input v-model="crowdfundForm.explanation" type="textarea" :rows="3" placeholder="选填"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="crowdfundDialog = false">取消</el-button>
                    <el-button type="primary" :loading="converting" @click="submitCrowdfund">确认发起</el-button>
                </span>
            </el-dialog>
        </template>
    </div>
</template>

<script>
import { getEntryDetail, followIntent, cancelFollowIntent, getCurrentPeriod, downloadEntry, initAuditionCrowdfunding, createAuditionOrder } from '@/api/audition'
import { queryLotteryType } from '@/api/common'
import EntryDetailPanel from './components/EntryDetailPanel.vue'
import RecentRecordGrid from './components/RecentRecordGrid.vue'
import { filterAuditionLotteryOptions, hxwyszHomeLocation } from './utils'

export default {
    components: { EntryDetailPanel, RecentRecordGrid },
    data () {
        return {
            loading: false,
            downloading: false,
            purchasing: false,
            detail: null,
            lotteryOptions: [],
            followThreshold: 50,
            followCanceling: false,
            crowdfundDialog: false,
            converting: false,
            crowdfundForm: {
                title: '',
                issueNumber: '',
                lotteryType: '',
                bettingShopNumber: '',
                bettingShopAddress: '',
                crowdfundingAmount: 1000,
                crowdfundingNumber: 100,
                crowdfundingPrice: 10,
                personLimit: 0,
                explanation: '',
                scheme: null
            }
        }
    },
    computed: {
        loggedIn () {
            return !!this.vuex_token
        }
    },
    watch: {
        '$route.params.id' (id, previous) {
            if (id && id !== previous) {
                this.loadDetail()
            }
        }
    },
    mounted () {
        this.loadLotteryTypes()
        this.loadDetail()
    },
    methods: {
        goBack () {
            const preType = (this.detail && this.detail.preType) || this.$route.query.preType
            this.$router.push(hxwyszHomeLocation(preType))
        },
        loadLotteryTypes () {
            queryLotteryType().then(res => {
                if (res.code === 200) {
                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)
                }
            })
        },
        loadPeriodThreshold (preType) {
            if (!preType) return
            getCurrentPeriod(preType).then(res => {
                if (res.code === 200 && res.data) {
                    this.followThreshold = res.data.followIntentThreshold || 50
                }
            })
        },
        loadDetail () {
            this.loading = true
            return getEntryDetail(this.$route.params.id).then(res => {
                if (res.code === 200) {
                    this.detail = res.data
                    this.loadPeriodThreshold(this.detail.preType)
                } else if (Number(res.code) === 401) {
                    this.$message.warning('请登录后查看方案')
                    this.goLogin()
                } else {
                    this.$message.error(res.msg || '加载失败')
                }
                this.loading = false
                return res
            }).catch(error => {
                this.loading = false
                throw error
            })
        },
        goLogin () {
            this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
        },
        handleFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            followIntent(this.detail.id).then(res => {
                if (res.code === 200) {
                    this.$message.success((res.header && res.header.msg) || res.msg || '已表达跟单意向')
                    this.loadDetail()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            })
        },
        handleCancelFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            this.$confirm('确定取消跟单意向吗？', '提示', { type: 'warning' }).then(() => {
                this.followCanceling = true
                cancelFollowIntent(this.detail.id).then(res => {
                    if (res.code === 200) {
                        this.$message.success((res.header && res.header.msg) || res.msg || '已取消跟单意向')
                        this.loadDetail()
                    } else {
                        this.$message.error(res.msg || '操作失败')
                    }
                    this.followCanceling = false
                }).catch(() => { this.followCanceling = false })
            }).catch(() => {})
        },
        handleDownload () {
            if (!this.detail || !this.detail.id) return
            if (!this.detail.contentUnlocked) {
                this.$message.warning('请先购买解锁方案')
                return
            }
            this.downloading = true
            downloadEntry(this.detail.id).then(res => {
                if (!res || !(res instanceof Blob)) {
                    this.handleBusinessError(res, '下载失败，请稍后重试')
                    this.downloading = false
                    return
                }
                res.arrayBuffer().then(buffer => {
                    const bytes = new Uint8Array(buffer)
                    const contentType = String(res.type || '').toLowerCase()
                    const looksJson = contentType.includes('json') || (bytes[0] === 0x7B || bytes[0] === 0x5B)
                    if (looksJson) {
                        this.showBlobError(bytes)
                        this.downloading = false
                        return
                    }
                    let fileName = this.detail.attachmentFileName
                    if (!fileName) {
                        const base = (this.detail.title || '海选方案').replace(/[\\/:*?"<>|]/g, '_')
                        fileName = base + '.txt'
                    }
                    this.$utils.downloadFile(bytes, fileName, 'text/plain;charset=utf-8')
                    this.downloading = false
                }).catch(() => {
                    this.$message.error('下载失败，请稍后重试')
                    this.downloading = false
                })
            }).catch(error => {
                this.handleBusinessError(error, '下载失败，请稍后重试')
                this.downloading = false
            })
        },
        handlePurchase () {
            if (!this.detail || this.purchasing) return
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            if (this.detail.contentUnlocked) {
                this.$message.success('方案已解锁')
                return
            }
            if (!this.detail.productId || !this.detail.productSpecsId) {
                this.$message.warning('商品尚未上架，请稍后再试')
                return
            }
            this.$confirm(
                `将使用余额支付 ${Number(this.detail.chargePrice).toLocaleString()} 缩币，确认购买并解锁？`,
                '购买确认',
                { confirmButtonText: '确认支付', cancelButtonText: '取消', type: 'warning' }
            ).then(async () => {
                this.purchasing = true
                try {
                    const res = await createAuditionOrder(this.detail)
                    if (!res || res.code !== 200) {
                        this.handleBusinessError(res, '支付失败，请稍后重试')
                        return
                    }
                    await this.loadDetail()
                    if (this.detail && this.detail.contentUnlocked) {
                        this.$message.success(this.detail.purchased ? '购买成功，方案已解锁' : '方案已解锁')
                    } else {
                        this.$message.warning('订单正在处理，请稍后刷新；方案未解锁前不会开放内容')
                    }
                } catch (error) {
                    this.handleBusinessError(error, '支付失败，请稍后重试')
                } finally {
                    this.purchasing = false
                }
            }).catch(() => {})
        },
        handleBusinessError (res, fallback) {
            const code = Number(res && res.code)
            const msg = String((res && (res.msg || res.message)) || fallback)
            if (code === 401) {
                this.$message.warning('登录已失效，请重新登录')
                this.goLogin()
                return
            }
            if (/余额|不足|缩币不足/.test(msg)) {
                this.$message.warning('缩币余额不足，请充值后再试')
            } else if (/已购|已购买|重复购买/.test(msg)) {
                this.$message.info('该方案已购买，正在刷新解锁状态')
                this.loadDetail()
            } else if (/待支付|处理中/.test(msg)) {
                this.$message.warning('已有待支付订单，请完成或关闭后再试')
            } else if (/退款|退回/.test(msg)) {
                this.$message.warning('订单已退款，方案内容已重新锁定')
                this.loadDetail()
            } else {
                this.$message.error(msg)
            }
        },
        showBlobError (bytes) {
            let msg = '下载失败，请稍后重试'
            try {
                const text = new TextDecoder('utf-8').decode(bytes)
                const data = JSON.parse(text)
                msg = data.msg || data.message || msg
                this.handleBusinessError(data, msg)
                return
            } catch (e) {
                // 非 JSON 错误响应，使用统一提示
            }
            this.$message.error(msg)
        },
        openCrowdfund () {
            if (!this.detail) return
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            this.crowdfundForm = {
                title: this.detail.title || '',
                issueNumber: this.detail.issueNumber || '',
                lotteryType: this.detail.preType || '',
                bettingShopNumber: '',
                bettingShopAddress: '',
                crowdfundingAmount: 1000,
                crowdfundingNumber: 100,
                crowdfundingPrice: 10,
                personLimit: 0,
                explanation: '',
                // 海选桥接：scheme 校验要求非空，默认取海选方案 id（后端以 entryId 维系真实关联）
                scheme: this.detail.id
            }
            this.crowdfundDialog = true
        },
        preTypeLabelOf (preType) {
            if (!preType) return '-'
            const item = this.lotteryOptions.find(o => o.dictValue === preType)
            return item ? item.dictLabel : preType
        },
        submitCrowdfund () {
            const f = this.crowdfundForm
            if (!f.issueNumber || !f.lotteryType || !f.bettingShopNumber || !f.bettingShopAddress) {
                this.$message.warning('请补全出票站号、站点等必填项')
                return
            }
            if (!f.crowdfundingAmount || f.crowdfundingAmount <= 0
                || !f.crowdfundingNumber || f.crowdfundingNumber < 1
                || !f.crowdfundingPrice || f.crowdfundingPrice <= 0) {
                this.$message.warning('请填写合法的众筹总额/股数/每股价格')
                return
            }
            this.converting = true
            const body = {
                title: f.title,
                issueNumber: f.issueNumber,
                lotteryType: f.lotteryType,
                scheme: f.scheme,
                bettingShopNumber: f.bettingShopNumber,
                bettingShopAddress: f.bettingShopAddress,
                crowdfundingAmount: f.crowdfundingAmount,
                crowdfundingNumber: f.crowdfundingNumber,
                crowdfundingPrice: f.crowdfundingPrice,
                personLimit: f.personLimit > 0 ? f.personLimit : null,
                explanation: f.explanation,
                auditionEntryId: this.detail.id
            }
            initAuditionCrowdfunding(this.detail.id, body)
                .then((res) => {
                    if (res && res.code === 200) {
                        this.$message.success((res.header && res.header.msg) || res.msg || '已发起众筹招股')
                        this.crowdfundDialog = false
                        this.$router.push('/sttzzbfzx/zhaogu')
                    } else {
                        this.$message.error((res && res.msg) || '发起失败')
                    }
                    this.converting = false
                })
                .catch(() => { this.converting = false })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./audition.scss";

.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 2px;
}
</style>
